export const capitalize = (str: string) => {
  return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
};

export const allCapsToCamelCase = (str: string) => {
  return str.toLowerCase().replace(/_([a-z])/g, (_, char) => char.toUpperCase());
};

export const truncateToLength = (str: string, length: number) => {
  return str.length > length ? str.slice(0, length - 1) + '…' : str;
};
